<app-sankey-chart [loading]="isLoading" [series]="series"></app-sankey-chart>
<p class="truncated-hint" *ngIf="truncated">
  {{ 'pages.analytics.semantics.treeTruncated' | translate }}
</p>
